module.exports = __webpack_public_path__ + "img/whatsapp.923b43a7.svg";